import { route, typeParser } from 'route-type-safe';

export const routes = {
  HOME: route({ path: '/dashboard' }),

  ACCOUNT: route({ path: '/account' }),
  PREFERENCE: route({ path: '/preference' }),

  MEMBER: route({ path: '/member' }),
  MEMBER_LOGIN: route({ path: '/member/login' }),
  MEMBER_FIND_ID: route({ path: '/member/find-id' }),
  MEMBER_FIND_ID_SUCCESS: route({ path: '/member/find-id-success' }),
  MEMBER_RESET_PWD: route({ path: '/member/reset-pwd' }),
  MEMBER_NEWPWD: route({ path: '/member/reset-password/:url', typeParam: { url: typeParser.string.required } }),

  ORGANIZATION: route({ path: '/organization' }),
  ORGANIZATION_CREATE: route({ path: '/organization/create' }),
  ORGANIZATION_ADD_SUB_LIST: route({ path: '/organization/add-sub-list' }),
  ORGANIZATION_DETAIL: route({
    path: '/organization/detail/:eat',
    typeParam: { eat: typeParser.string.required },
    typeState: { from: typeParser.string.optional },
  }),
  ORGANIZATION_EDIT: route({ path: '/organization/detail/:eat/edit', typeParam: { eat: typeParser.string.required } }),
  ORGANIZATION_CHART: route({ path: '/organization/chart' }),
  ORGANIZATION_SUMMARY: route({ path: '/organization/chart/summary' }),

  DISTRIBUTOR: route({ path: '/distributor' }),
  DISTRIBUTOR_CREATE: route({ path: '/distributor/create' }),
  DISTRIBUTOR_DETAIL: route({
    path: '/distributor/detail/:eat',
    typeParam: { eat: typeParser.string.required },
  }),
  DISTRIBUTOR_EDIT: route({
    path: '/distributor/detail/:eat/edit',
    typeParam: { eat: typeParser.string.required },
  }),

  USER: route({ path: '/user' }),
  USER_CREATE: route({ path: '/user/create' }),
  USER_DETAIL: route({ path: '/user/detail/:userId', typeParam: { userId: typeParser.string.required } }),
  USER_EDIT: route({ path: '/user/detail/:userId/edit', typeParam: { userId: typeParser.string.required } }),
  // J: Edit with react-hook-form
  USER_EDIT_RHF: route({ path: '/user/detail/:userId/editRHF', typeParam: { userId: typeParser.string.required } }),
  // J: Create with react-hook-form
  USER_CREATE_RHF: route({ path: '/user/createRHF' }),

  ROLE: route({ path: '/privilege/role' }),
  ROLE_CREATE: route({ path: '/privilege/role/create' }),
  // J: Create with react-hook-form
  ROLE_CREATE_RHF: route({ path: '/privilege/role/createRHF' }),
  ROLE_DETAIL: route({ path: '/privilege/role/detail/:roleName', typeParam: { roleName: typeParser.string.required } }),
  ROLE_EDIT: route({
    path: '/privilege/role/detail/:roleName/edit',
    typeParam: { roleName: typeParser.string.required },
  }),
  // J: Update with react-hook-form
  ROLE_EDIT_RHF: route({
    path: '/privilege/role/detail/:roleName/editRHF',
    typeParam: { roleName: typeParser.string.required },
  }),

  FUNCTION: route({ path: '/privilege/function' }),
  FUNCTION_CREATE: route({ path: '/privilege/function/create' }),
  FUNCTION_DETAIL: route({
    path: '/privilege/function/detail/:functionName',
    typeParam: { functionName: typeParser.string.required },
  }),
  FUNCTION_EDIT: route({
    path: '/privilege/function/detail/:functionName/edit',
    typeParam: { functionName: typeParser.string.required },
  }),

  MENU: route({ path: '/privilege/menu' }),
  MENU_CREATE: route({ path: '/privilege/menu/create' }),
  MENU_DETAIL: route({ path: '/privilege/menu/detail/:menuName', typeParam: { menuName: typeParser.string.required } }),
  MENU_EDIT: route({
    path: '/privilege/menu/detail/:menuName/edit',
    typeParam: { menuName: typeParser.string.required },
  }),

  RESOURCE: route({ path: '/privilege/resource' }),
  RESOURCE_CREATE: route({ path: '/privilege/resource/create' }),
  RESOURCE_DETAIL: route({
    path: '/privilege/resource/detail/:resourceName',
    typeParam: { resourceName: typeParser.string.required },
  }),
  RESOURCE_EDIT: route({
    path: '/privilege/resource/detail/:resourceName/edit',
    typeParam: { resourceName: typeParser.string.required },
  }),

  PATIENT: route({
    path: '/patient',
    typeQuery: {
      service: typeParser.string.optional,
    },
  }),
  PATIENT_CREATE: route({ path: '/patient/create' }),
  PATIENT_DETAIL: route({ path: '/patient/detail/:pat', typeParam: { pat: typeParser.string.required } }),
  PATIENT_EDIT: route({ path: '/patient/detail/:pat/edit', typeParam: { pat: typeParser.string.required } }),
  PATIENT_DEVICE_CONNECTION: route({ path: '/patient/device-connection' }),

  PATIENT_DETAIL_SETTING: route({ path: '/page-setting/patient' }),
  REPORT_PATIENT: route({
    path: '/report/patient',
    typeQuery: {
      from: typeParser.string.required,
      to: typeParser.string.required,
      pat: typeParser.string.required,
      detailInfo: typeParser.string.optional,
    },
  }),
  RAW_REPORT_PATIENT: route({
    path: '/report/patient/raw',
    typeQuery: {
      from: typeParser.string.required,
      to: typeParser.string.required,
      pat: typeParser.string.required,
      detailInfo: typeParser.string.optional,
      userId: typeParser.string.required,
      settingUserId: typeParser.string.optional,
    },
  }),

  DEVICE: route({
    path: '/device',
    typeQuery: {
      service: typeParser.string.optional,
    },
  }),
  DEVICE_CREATE: route({ path: '/device/create' }),
  DEVICE_DETAIL: route({ path: '/device/detail/:dat', typeParam: { dat: typeParser.string.required } }),
  DEVICE_EDIT: route({
    path: '/device/detail/:dat/edit',
    typeParam: { dat: typeParser.string.required },
  }),

  MANIFEST: route({ path: '/manifest' }),
  MANIFEST_CREATE: route({ path: '/manifest/create' }),
  MANIFEST_DETAIL: route({
    path: '/manifest/detail/:manufacturerCode/:model/:version',
    typeParam: {
      manufacturerCode: typeParser.string.required,
      model: typeParser.string.required,
      version: typeParser.string.required,
    },
  }),
  MANIFEST_EDIT: route({
    path: '/manifest/detail/:manufacturerCode/:model/:version/edit',
    typeParam: {
      manufacturerCode: typeParser.string.required,
      model: typeParser.string.required,
      version: typeParser.string.required,
    },
  }),

  GROUP_CODE: route({ path: '/group-code' }),
  GROUP_CODE_CREATE: route({ path: '/group-code/create' }),
  // J: Create with react-hook-form
  GROUP_CODE_CREATE_RHF: route({ path: '/group-code/createRHF' }),
  GROUP_CODE_DETAIL: route({
    path: '/group-code/detail/:grpCode',
    typeParam: { grpCode: typeParser.string.required },
  }),
  GROUP_CODE_EDIT: route({
    path: '/group-code/detail/:grpCode/edit',
    typeParam: { grpCode: typeParser.string.required },
  }),
  // J: Update with react-hook-form
  GROUP_CODE_EDIT_RHF: route({
    path: '/group-code/detail/:grpCode/editRHF',
    typeParam: { grpCode: typeParser.string.required },
  }),

  DETAIL_CODE: route({ path: '/detail-code' }),
  DETAIL_CODE_CREATE: route({ path: '/detail-code/create' }),
  // J: Create with react-hook-form
  DETAIL_CODE_CREATE_RHF: route({ path: '/detail-code/createRHF' }),
  DETAIL_CODE_DETAIL: route({
    path: '/detail-code/detail/:grpCode/:dtlCode',
    typeParam: { grpCode: typeParser.string.required, dtlCode: typeParser.string.required },
  }),
  DETAIL_CODE_EDIT: route({
    path: '/detail-code/detail/:grpCode/:dtlCode/edit',
    typeParam: { grpCode: typeParser.string.required, dtlCode: typeParser.string.required },
  }),
  // J: Update with react-hook-form
  DETAIL_CODE_EDIT_RHF: route({
    path: '/detail-code/detail/:grpCode/:dtlCode/editRHF',
    typeParam: { grpCode: typeParser.string.required, dtlCode: typeParser.string.required },
  }),

  DICTIONARY_OVERVIEW: route({ path: '/dictionary/overview' }),
  DICTIONARY: route({ path: '/dictionary' }),
  DICTIONARY_CREATE: route({ path: '/dictionary/create' }),
  DICTIONARY_DETAIL: route({
    path: '/dictionary/detail/:version',
    typeParam: { version: typeParser.string.required },
  }),
  DICTIONARY_EDIT: route({
    path: '/dictionary/detail/:version/edit',
    typeParam: { version: typeParser.string.required },
  }),

  SEMANTICS: route({ path: '/dictionary/semantics' }),
  SEMANTICS_CREATE: route({ path: '/dictionary/semantics/create' }),
  SEMANTICS_DETAIL: route({
    path: '/dictionary/semantics/detail/:version',
    typeParam: { version: typeParser.string.required },
  }),
  SEMANTICS_EDIT: route({
    path: '/dictionary/semantics/detail/:version/edit',
    typeParam: { version: typeParser.string.required },
  }),

  TAG: route({ path: '/dictionary/tag' }),
  TAG_CREATE: route({ path: '/dictionary/tag/create' }),
  TAG_DETAIL: route({ path: '/dictionary/tag/detail/:tag', typeParam: { tag: typeParser.string.required } }),
  TAG_EDIT: route({ path: '/dictionary/tag/detail/:tag/edit', typeParam: { tag: typeParser.string.required } }),

  PAGE_ERROR_DEFAULT: route({ path: '/*' }),

  FILTER: route({ path: '/filter' }),
  FILTER_CREATE: route({ path: '/filter/create' }),
  FILTER_DETAIL: route({ path: '/filter/detail/:filterName', typeParam: { filterName: typeParser.string.required } }),
  FILTER_EDIT: route({
    path: '/filter/detail/:filterName/edit',
    typeParam: { filterName: typeParser.string.required },
  }),

  LOG: route({ path: '/log' }),
  LOG_DETAIL: route({ path: '/log/detail/:id', typeParam: { id: typeParser.string.required } }),

  MONITORING: route({ path: '/monitoring' }),
  MONITORING_INGEST: route({ path: '/monitoring/ingest' }),

  MANAGEMENT: route({ path: '/management' }),

  SYS_SETTING: route({ path: '/sysSetting' }),
  SYS_SETTING_CREATE: route({ path: '/sysSetting/create' }),
  SYS_SETTING_DETAIL: route({
    path: '/sysSetting/detail/:category/:keyName',
    typeParam: { category: typeParser.string.required, keyName: typeParser.string.required },
  }),
  SYS_SETTING_EDIT: route({
    path: '/sysSetting/detail/:category/:keyName/edit',
    typeParam: { category: typeParser.string.required, keyName: typeParser.string.required },
  }),

  SERVERS: route({ path: '/servers' }),
  SERVERS_CREATE: route({ path: '/servers/create' }),
  // J: Create with react-hook-form
  SERVERS_CREATE_RHF: route({ path: '/servers/createRHF' }),
  SERVERS_DETAIL: route({
    path: '/servers/detail/:serial',
    typeParam: { serial: typeParser.string.required },
  }),
  SERVERS_EDIT: route({
    path: '/servers/detail/:serial/edit',
    typeParam: { serial: typeParser.string.required },
  }),

  LICENSE: route({ path: '/license' }),
  LICENSE_CREATE: route({ path: '/license/create' }),
  LICENSE_DETAIL: route({ path: '/license/detail/:licenseId', typeParam: { licenseId: typeParser.string.required } }),
  LICENSE_EDIT: route({
    path: '/license/detail/:licenseId/edit',
    typeParam: { licenseId: typeParser.string.required },
  }),

  ORDER: route({ path: '/order' }),
  ORDER_CREATE: route({ path: '/order/create' }),
  ORDER_DETAIL: route({ path: '/order/detail/:orderId', typeParam: { orderId: typeParser.string.required } }),
  ORDER_EDIT: route({
    path: '/order/detail/:orderId/edit',
    typeParam: { orderId: typeParser.string.required },
  }),

  UNDER_CONSTRUCTION: route({ path: '/new-feature' }),

  ERROR_404: route({ path: '/error404' }),
};

export type RoutePaths = (typeof routes)[keyof typeof routes]['path'];
